import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CdsLanguageModule } from '@cds/ng-core/lang';

import { CdTableTitleComponent } from './cd-table-title.component';

@NgModule({
  imports: [CommonModule, CdsLanguageModule, CdTableTitleComponent],
  exports: [CdTableTitleComponent],
})
export class CdTableTitleModule {}
